import validate from "/home/ubuntu/frontend-deploy/repo/continous/node_modules/nuxt/dist/pages/runtime/validate.js";
import previous_45route_45global from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/middleware/previous-route.global.ts";
import route_45global from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/middleware/route.global.ts";
import manifest_45route_45rule from "/home/ubuntu/frontend-deploy/repo/continous/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  previous_45route_45global,
  route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/middleware/auth.ts")
}